// extracted by mini-css-extract-plugin
module.exports = {"span":"FirstLetter_span__1fzZc"};